import classNames from 'classnames';
import React from 'react';

export function AttachmentInputFooter(props: {
  allowedFormats: string[];
  maxFileSizeMb: number;
}) {
  return (
    <div
      className={classNames(
        'd-flex',
        'justify-content-between',
        'text-dark-200',
      )}
    >
      <small>
        {props.allowedFormats.length !== 0
          ? 'Allowed file formats: ' + props.allowedFormats.join(', ')
          : ''}
      </small>
      <small>{`Max file size: ${props.maxFileSizeMb}MB`}</small>
    </div>
  );
}
